import Link from "next/link";

import type { SiteLocale } from "@/lib/graphql";

import { type FragmentOf, readFragment } from "~/lib/graphql";

import * as fragment from "./graphql";

export function DownloadSectionFile(props: {
  record: FragmentOf<typeof fragment.downloadSectionFileFragment>;
  locale: SiteLocale;
}) {
  const record = readFragment(fragment.downloadSectionFileFragment, props.record);

  return (
    <div>
      <Link
        href={record.file.url}
        className="font-eurac-red group container mx-auto my-0 block max-w-[780px] py-6 text-[16px]"
      >
        <div className="flex items-center gap-4">
          <div className="shrink-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="88"
              height="89"
              fill="none"
              viewBox="0 0 88 89"
            >
              <g clipPath="url(#clip0_2325_227)">
                <circle
                  cx="44"
                  cy="44.336"
                  r="43"
                  stroke="#DF1B12"
                  strokeWidth="2"
                  className="transition-colors group-hover:fill-[#DF1B12]"
                ></circle>
                <path
                  fill="#DF1B12"
                  className="transition-colors group-hover:fill-white"
                  d="M49.353 19.336a.9.9 0 0 1 .729.373l12.423 12.795a.95.95 0 0 1 .342.869l-.171 35.03a.916.916 0 0 1-.902.933H26.061a.93.93 0 0 1-.916-.932V20.267a.93.93 0 0 1 .916-.931zm-22.267 48.09h33.943V34.164H49.431a.92.92 0 0 1-.917-.932V21.199H27.086zm29.611-6.165v1.864H31.433V61.26zm-11.724-8.12 4.953-4.955 1.32 1.32-6.553 6.553a.92.92 0 0 1-1.32 0l-6.553-6.552 1.32-1.32 4.985 4.938V37.596h1.879zm5.358-20.87h9.425l-9.425-9.768z"
                ></path>
              </g>
              <defs>
                <clipPath id="clip0_2325_227">
                  <path fill="#fff" d="M0 .336h88v88H0z"></path>
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="space-y-2">
            {record.title && (
              <h2 className="text-base leading-none font-bold text-[#df1b12]">
                {record.title}
              </h2>
            )}
            {record.description && <p className="text-eurac-red">{record.description}</p>}
          </div>
        </div>
      </Link>
    </div>
  );
}
